export const account = {
	email: "pwa@shoppbud.com.br",
	password: "12345678",
	provider: "email",
};
